import { FC } from 'react';

export const NotFound: FC = () => <div>Page is not found</div>;
